<div
  class="currency-container"
  [attr.data-size]="size"
  [attr.data-disabled]="disabled"
  [attr.data-error]="error"
  [attr.data-has-value]="_centAmount > 0"
  (mousedown)="onContainerMouseDown($event)"
>
  <label *ngIf="label" class="currency-label" [for]="inputId">
    {{ label }}
    <span *ngIf="required" class="required-indicator" aria-hidden="true"
      >*</span
    >
  </label>

  <div class="currency-wrapper">
    <span class="currency-icon" aria-hidden="true">
      <umss-icon name="phosphorCurrencyDollar" [size]="iconSize" />
    </span>

    <input
      #inputEl
      class="currency-field"
      type="number"
      inputmode="decimal"
      [id]="inputId"
      [value]="formatOn === 'input' ? displayValue : editableValue"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [required]="required"
      [name]="name ?? ''"
      [attr.min]="0"
      [attr.max]="max"
      [attr.aria-required]="required"
      [attr.aria-invalid]="error"
      [attr.aria-label]="label ? null : ariaLabel"
      [attr.aria-describedby]="describedBy"
      (keydown)="onKeyDown($event)"
      (input)="onNativeInput($event)"
      (paste)="onPaste($event)"
      (focus)="onFocusEvent()"
      (blur)="onBlurEvent()"
    />

    <span *ngIf="suffix" class="currency-suffix" [id]="suffixId">{{
      suffix
    }}</span>
  </div>

  <p
    *ngIf="error && errorMessage"
    class="error-message"
    [id]="errorId"
    role="alert"
    aria-live="polite"
  >
    {{ errorMessage }}
  </p>
  <p *ngIf="!error && helperText" class="helper-text" [id]="helperId">
    {{ helperText }}
  </p>
</div>
